// Thin client for the platform accounts BFF (separate origin; CORS
// allow-listed there). Everything degrades to null when
// env.accountsApiBaseUrl is unconfigured (k3d, local) — consumers hide the
// sign-out affordance. The product switcher reads platform's API instead
// (src/api/platform.ts).

import { env } from "@/lib/env";
import { parseErrorResponse } from "./transport";

async function bffFetch<T>(path: string, init?: RequestInit): Promise<T | null> {
    if (!env.accountsApiBaseUrl) return null;
    const res = await fetch(`${env.accountsApiBaseUrl}/v1${path}`, {
        credentials: "include",
        ...init,
        headers: {
            Accept: "application/json",
            ...(init?.body ? { "Content-Type": "application/json" } : {}),
            ...init?.headers,
        },
    });
    if (!res.ok) throw await parseErrorResponse(res);
    return (await res.json()) as T;
}

export function signOutEnabled(): boolean {
    return Boolean(env.accountsApiBaseUrl);
}

/**
 * POST /v1/logout on the BFF returns a fully built RP-initiated logout URL
 * (oauth2-proxy sign_out → IdP end_session → returnTo). Null when the BFF
 * is unconfigured or unreachable — callers hide the sign-out affordance.
 */
export async function fetchSignOutUrl(returnTo: string = `${window.location.origin}/`): Promise<string | null> {
    if (!env.accountsApiBaseUrl) return null;
    try {
        const body = await bffFetch<{ signOutUrl: string }>("/logout", {
            method: "POST",
            body: JSON.stringify({ returnTo }),
        });
        return body?.signOutUrl ?? null;
    } catch {
        return null;
    }
}
